<template>
  <router-view :key="$route.fullPath"/>
</template>

<script>
import {getAuthToken, removeAuthData} from "@/libs/auth-helper";

export default {
  name: 'TheMember',
  beforeRouteUpdate(to, from, next) {
    this.authToken = getAuthToken();
    if (!this.authToken) {
      removeAuthData();
      this.$router.replace({ name: "login" });
    } else {
      next()
    }
  },
  async created() {
    await this.$store.dispatch('storeSiteData')
  }
}
</script>

<style scoped>
.page-container {
  padding: 15px 15px;
  position: relative;
}
</style>
